import { ThemeConfig } from '@chakra-ui/react'

export const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
}
